import { render, staticRenderFns } from "./Intervoice.vue?vue&type=template&id=5e3e70ae"
import script from "./Intervoice.vue?vue&type=script&lang=js"
export * from "./Intervoice.vue?vue&type=script&lang=js"
import style0 from "./Intervoice.vue?vue&type=style&index=0&id=5e3e70ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports